import {LayoutIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#000",
      "fill-opacity": ".4",
      d: "M6.753 10.5a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#000",
      "fill-opacity": ".4",
      d: "M18 21a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3h8.25L18 6.75zM3 1.5A1.5 1.5 0 0 0 1.5 3v15l3.336-3.336a.75.75 0 0 1 .915-.112L9 16.5l3.236-4.53a.75.75 0 0 1 1.14-.095L16.5 15V6.75h-3a2.25 2.25 0 0 1-2.25-2.25v-3z"
    }, null, -1)
  ]))]))
}
export default { render() { return h(LayoutIcon, {icon: {render}, name: "image"}) } }